import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Contributor from "../../atoms/contributor";
import styles from "./styles.m.css";
import { getAuthorPath } from "../../../data/author";
import Icon from "../icon";

const SocialShareSection = ({ story, config }) => {
  const ref = useRef(null);
  const [authorView, setauthorView] = useState(false);

  const handleAuthorClick = () => {
    setauthorView(!authorView);
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setauthorView(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const excludedRoles = [
    "Proof Reader",
    "Moderated by",
    "Channel Manager",
    "Publisher",
    "Digital Publisher",
    "Layout Artist",
    "Ideation",
    "Sub Editor"
  ];

  const storyAuthors =
    story.authors && story.authors.length
      ? story.authors.filter(author => {
          const contributorRole = get(author, ["contributor-role", "name"]);
          return !excludedRoles.includes(contributorRole);
        })
      : "";

  return (
    <div className={styles["socail-author-container"]} ref={ref}>
      <div className={styles["author"]}>
        <div className={styles["author-grid"]}>
          {storyAuthors
            ? storyAuthors.map((author, index) => {
                if (index <= 1) {
                  return (
                    <Contributor
                      config={config}
                      key={author.id}
                      name={author.name}
                      type={get(author, ["contributor-role", "name"], "")}
                      iconColor="#4a4a4a"
                      className={styles["contributor"]}
                      path={`${getAuthorPath(author)}`}
                    />
                  );
                }
              })
            : null}
        </div>
        <div className={styles["contributor-count-container"]}>
          {storyAuthors &&
            storyAuthors > 2 && (
              <div className={styles["contributor-count"]} onClick={() => handleAuthorClick()}>
                <Icon type="more-outline" className={authorView ? styles["active-point"] : ""} />
              </div>
            )}
          {authorView ? (
            <div className={styles["contributorsview"]}>
              {storyAuthors.map((author, index) => {
                if (index !== 0 && index !== 1) {
                  return (
                    <Contributor
                      key={author.id}
                      name={author.name}
                      type={get(author, ["contributor-role", "name"], "")}
                      iconColor="#4a4a4a"
                      className={styles["contributor"]}
                      path={`/author/${author.slug}`}
                    />
                  );
                }
              })}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

SocialShareSection.propTypes = {
  story: PropTypes.shape(),
  config: PropTypes.shape()
};
export default SocialShareSection;
